export enum ApplicantCardActionTypes {
  OPEN_CHAT = 'OPEN_CHAT',
  PENDING = 'PENDING',
}
